import { useLocation } from 'react-router-dom';

export default function useRouteFrom() {
    const location = useLocation();
    const from = (location.state as { from: string })?.from;
    return from;
}
